import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import InputField from '../../../Components/InputField';
import {
  buildPeopleList, getPersonLabel, setLink,
} from './attendeeLinking';

const COMPANION_OF_LABEL = 'Gemeinsame Nennung im Programmheft mit';
const COMPANION_OF_SHORT_HELP = 'Für eine gemeinsame Nennung im Programmheft, beispielsweise als Ehepaar. Die betreffende Person muss zuvor von Ihnen als Gast hinzugefügt worden sein.';

export default function CompanionOfField({ personId, showNameInProgrammSelection = false }) {
  const { values } = useFormState();
  const form = useForm();
  const people = buildPeopleList(values);
  const person = people.find((candidate) => candidate.id === personId);
  if (!person) return null;

  const availablePeople = people.filter((candidate) => candidate.id !== person.id);
  const unlinkedPeople = availablePeople.filter((candidate) => !candidate.companionOf);
  const linkedPeople = availablePeople.filter((candidate) => !!candidate.companionOf);
  const showInProgram = person.showInProgram === undefined
    || person.showInProgram === true
    || person.showInProgram === 'true';

  const handleShowInProgramChange = (event) => {
    const enabled = event.target.value === true || event.target.value === 'true';
    form.change(person.showInProgramFieldPath, enabled);
    if (!enabled) setLink(form, people, person.id, null);
  };

  return (
    <>
      {showNameInProgrammSelection && (
        <InputField
          name={person.showInProgramFieldPath}
          label="Nennung im Programmheft"
          gridSize={{ xs: 12, md: 6 }}
          type="select"
          options={[
            { value: true, name: 'Ja' },
            { value: false, name: 'Nein' },
          ]}
          onChange={handleShowInProgramChange}
        />
      )}
      {(!showNameInProgrammSelection || showInProgram) && (
        <InputField
          name={person.fieldPath}
          label={COMPANION_OF_LABEL}
          gridSize={{ xs: 12, md: 6 }}
          type="select"
          helperText={COMPANION_OF_SHORT_HELP}
          options={[{ value: '', name: '– keine gemeinsame Nennung –' }]}
          optionGroups={[
            {
              label: 'Ohne bisherige Verknüpfung',
              options: unlinkedPeople.map((candidate) => ({ value: candidate.id, name: getPersonLabel(candidate) })),
            },
            {
              label: 'Bereits verknüpft (Verknüpfung wird gelöst)',
              options: linkedPeople.map((candidate) => ({ value: candidate.id, name: getPersonLabel(candidate) })),
            },
          ]}
          onChange={(event) => setLink(form, people, person.id, event.target.value || null)}
        />
      )}
    </>
  );
}
